import { ShaderDataType } from "../../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "../../../layagl/LayaGL";
import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
import { Transform3D } from "../../core/Transform3D";
import { BaseRender } from "../../core/render/BaseRender";
import { SkyBox } from "./SkyBox";
import { SkyDome } from "./SkyDome";
export class SkyRenderer {
    static __init__() {
        SkyRenderer.SUNLIGHTDIRECTION = Shader3D.propertyNameToID("u_SunLight_direction");
        SkyRenderer.SUNLIGHTDIRCOLOR = Shader3D.propertyNameToID("u_SunLight_color");
        SkyRenderer.SKYVIEWMATRIX = Shader3D.propertyNameToID("u_SkyViewMat");
        SkyRenderer.SKYPROJECTIONMATRIX = Shader3D.propertyNameToID("u_SkyProjectionMat");
        SkyRenderer.SKYPROJECTIONVIEWMATRIX = Shader3D.propertyNameToID("u_SkyProjectionViewMat");
        const commandUniform = LayaGL.renderDeviceFactory.createGlobalUniformMap("SkyRenderer");
        commandUniform.addShaderUniform(SkyRenderer.SUNLIGHTDIRECTION, "u_SunLight_direction", ShaderDataType.Vector3);
        commandUniform.addShaderUniform(SkyRenderer.SUNLIGHTDIRCOLOR, "u_SunLight_color", ShaderDataType.Color);
        commandUniform.addShaderUniform(SkyRenderer.SKYVIEWMATRIX, "u_SkyViewMat", ShaderDataType.Matrix4x4);
        commandUniform.addShaderUniform(SkyRenderer.SKYPROJECTIONMATRIX, "u_SkyProjectionMat", ShaderDataType.Matrix4x4);
        commandUniform.addShaderUniform(SkyRenderer.SKYPROJECTIONVIEWMATRIX, "u_SkyProjectionViewMat", ShaderDataType.Matrix4x4);
    }
    get material() {
        return this._material;
    }
    set material(value) {
        if (this._material !== value) {
            (this._material) && (this._material._removeReference());
            this._material = value;
            this._cacheRenderElement && (this._cacheRenderElement.material = value);
            if (value) {
                value._addReference();
            }
        }
    }
    get mesh() {
        return this._mesh;
    }
    set mesh(value) {
        if (this._mesh !== value) {
            this._mesh = value;
            this._cacheRenderElement && this._cacheRenderElement.setGeometry(this.mesh);
        }
    }
    get meshType() {
        return this.mesh == SkyBox.instance ? "box" : (this.mesh == SkyDome.instance ? "dome" : "");
    }
    set meshType(value) {
        if (value == "dome")
            this.mesh = SkyDome.instance;
        else
            this.mesh = SkyBox.instance;
    }
    constructor() {
        this.mesh = SkyDome.instance;
        this._renderData = new BaseRender();
        this._baseRenderNode = Laya3DRender.Render3DModuleDataFactory.createBaseRenderNode();
        this._baseRenderNode.transform = new Transform3D(null);
    }
    _isAvailable() {
        return this._material && this._mesh ? true : false;
    }
    renderUpdate(context) {
        let geomettry = this.mesh;
        this._renderGeometry = geomettry._prepareRender(context);
        geomettry._updateRenderParams(context);
    }
    setRenderElement(skyRenderElement) {
        if (!skyRenderElement)
            return;
        if (this._cacheRenderElement != skyRenderElement) {
            skyRenderElement.setGeometry(this.mesh);
            skyRenderElement.material = this._material;
            skyRenderElement.render = this._renderData;
            skyRenderElement._renderElementOBJ.isRender = this._renderGeometry;
            this._baseRenderNode.shaderData = this._renderData._baseRenderNode.shaderData;
            this._baseRenderNode.setRenderelements([skyRenderElement._renderElementOBJ]);
            this._baseRenderNode.setCommonUniformMap([
                "Sprite3D",
                "SkyRenderer"
            ]);
            this._cacheRenderElement = skyRenderElement;
        }
        else {
            skyRenderElement.setGeometry(this.mesh);
            skyRenderElement.material = this._material;
            skyRenderElement.render = this._renderData;
            skyRenderElement._renderElementOBJ.isRender = this._renderGeometry;
        }
    }
    destroy() {
        if (this._material) {
            this._material._removeReference();
            this._material = null;
        }
        this._renderData.destroy();
        this._cacheRenderElement = null;
        this._baseRenderNode.setRenderelements([]);
        this._baseRenderNode.destroy();
    }
}
